"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetAnnotationTypeSchema = exports.NetAnnotationType = void 0;
const zod_1 = require("zod");
var NetAnnotationType;
(function (NetAnnotationType) {
    NetAnnotationType["Power"] = "power";
    NetAnnotationType["Ground"] = "ground";
    NetAnnotationType["Analog"] = "analog";
    NetAnnotationType["Digital"] = "digital";
    NetAnnotationType["BusClass"] = "bus-class";
})(NetAnnotationType || (exports.NetAnnotationType = NetAnnotationType = {}));
exports.NetAnnotationTypeSchema = zod_1.default.nativeEnum(NetAnnotationType);
//# sourceMappingURL=NetAnnotationType.js.map